<template>  
  <div>
    <card card-body-classes="px-3">
      <div slot="header" class="row">
        <div class="col-6">
          <h4 class="card-title f-20-mobile">Usuários</h4>
        </div>
      </div>

      <form class="row text-left" @submit="onSubmit">
        <div class="form-group col-6">
          <label>Nome</label>
          <input type="text" v-model="data.name" class="form-control" required>
        </div>

        <div class="form-group col-6">
          <label>Email</label>
          <input type="text" v-model="data.email" class="form-control">
        </div>

        <div class="form-group col-6">
          <label>Documento</label>
          <input type="text"  v-model="data.cpf" class="form-control">
        </div>

        <div class="form-group col-6">
          <label>Senha</label>
          <input type="password"  v-model="data.password" class="form-control">
        </div>

        <div class="form-group col-6">
          <label>Grupo Empresarial</label>
          <select type="text" v-model="data.customer_group_id"  class="form-control">
            <option>Selecione...</option>
            <option :value="group.id" v-for="group of groups">{{ group.name }}</option>
          </select>
        </div>

        <div class="form-group col-6">
          <label>Nivel de acesso</label>
          <select type="text" v-model="data.access_level"  class="form-control">
            <option value="0">Administrador</option>
            <option value="100">Contador</option>
            <option value="200">Acesso ao /admin</option>
          </select>
        </div>

        <div class="form-group col-12">
          <button class="btn btn-primary">{{ data.id ? 'Editar' : 'Salvar' }}</button>
        </div>
      </form>
    </card>
  </div>
</template>

<script>
  import axios from 'axios'
  import {
    Card,
  } from 'src/components'
import moment from 'moment'
import UserService from '@/services/UserService.js'
import CustomerGroupService from '@/services/CustomerGroupService.js'

export default {
    components: {
      Card,
      moment
    },
    data() {
      return {
        groups: [],
        data: {
          access_level: 0
        }
      }
    },
    props: [
      'user'
    ],
    methods:{
      loadGroups() {
        CustomerGroupService.loadOptimal().then(res => {
          this.groups = res.data
        })
        .catch(err => {

        })
      },
      loadUser(id) {
        UserService.show(id).then(res => {
          if(res.data.access_level == null) {
            res.data.access_level = 0;
          }

          this.data = res.data
        })
        .catch(err => {
          alert("FODASE")
        })
      },
      onSubmit(e) {
        e.preventDefault()

        if(this.data.id) {
          UserService.update(this.data).then(res => {
            this.$router.push('/usuarios/')
          })
          .catch(err => {

          })
        } else {
          UserService.create(this.data).then(res => {
            this.$router.push('/usuarios/')
          })
          .catch(err => {

          })
        }
      }
    },
    mounted() {

      if(this.$route.params.id) {
        this.loadUser(this.$route.params.id)
      }
      this.loadGroups()
    }
}
</script>

<style>
</style>  